import template from './project-list.pug';

export const ProjectListComponent = {
  template,
  bindings: {
    projects: '<',
    onSelect: '&',
  },
  controller: class ProjectListComponent {
    constructor() {
      'ngInject';
    }

    $onInit() {
    }

    toggleProject(selectedId) {
      this.projects.map((project) => {
        if (project.id == selectedId) {
          project.selected = !project.selected
        }
      });
      this.updateProjects();
    }

    updateProjects() {
      const selectedIds = this.projects.filter((project) => project.selected).map((project) => project.id);
      this.onSelect({ $event: { projects: selectedIds } });
    }
  },
};
